import { Box, IconButton, SvgIcon } from '@mui/material';
import { FC } from 'react';
import NextIcon from '../../../../../../icons/svg/arrow_right_smaller.svg?react';
import PreviousIcon from '../../../../../../icons/svg/arrow_left_smaller.svg?react';
import { TablePaginationActionsProps } from '@mui/material/TablePagination/TablePaginationActions';

type Props = Pick<TablePaginationActionsProps, 'onPageChange' | 'page' | 'count' | 'rowsPerPage'>;

export const TablePaginationActions: FC<Props> = ({ onPageChange, page, count, rowsPerPage }) => {
  return (
    <Box sx={{ display: 'flex', marginLeft: '30px' }}>
      <IconButton
        disableRipple
        onClick={(event) => onPageChange(event, page - 1)}
        disabled={page === 0}
        sx={{
          '&.Mui-disabled': {
            opacity: '0.3'
          },
          height: '45px',
          width: '45px'
        }}
      >
        <SvgIcon
          component={PreviousIcon}
          color="primary"
          sx={{
            '&:hover': {
              color: 'secondary.main'
            }
          }}
        />
      </IconButton>
      <IconButton
        disableRipple
        onClick={(event) => onPageChange(event, page + 1)}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        sx={{
          '&.Mui-disabled': {
            opacity: '0.3'
          },
          height: '45px',
          width: '45px'
        }}
      >
        <SvgIcon
          component={NextIcon}
          color="primary"
          sx={{
            '&:hover': {
              color: 'grey.900'
            }
          }}
        />
      </IconButton>
    </Box>
  );
};
